import { TableOLD } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { getTableColumns, getTableRows } from '../utils'

import styles from './StockDiscrepanciesLogTable.module.less'

export default function StockDiscrepanciesLogTable(props) {
  const { logs } = props

  return (
    <div className={styles.wrapper}>
      <TableOLD
        columns={getTableColumns()}
        rows={getTableRows({ logs })}
        onChange={() => {
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
        }}
        pagination={{
          hideOnSinglePage: true,
          position: ['bottomCenter']
        }}
      />
    </div>
  )
}

StockDiscrepanciesLogTable.propTypes = {
  logs: PropTypes.array.isRequired
}
